export default __webpack_public_path__ + "src/docs/packages/saseka-tented-camp.pdf";